// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import React from 'react';
import { Footer } from "@dip/helsecore/src/components/parts/Footer/Footer";
import type { FooterProps } from "@dip/helsecore/src/components/parts/Footer/Footer.d";

export default (props: Readonly<FooterProps>) => <Footer {...props} />
